/**
 * Tenant detection from hostname.
 *
 * Main app:  ucdp.bigdatamatica.com       → no tenant (admin)
 * Tenants:   infosys.bigdatamatica.com    → slug "infosys"
 *            tcs.bigdatamatica.com        → slug "tcs"
 *            microsoft.bigdatamatica.com  → slug "microsoft"
 *
 * Local dev: localhost / 127.0.0.1        → no tenant
 */

const BASE_DOMAIN = "usecases.tech";
const MAIN_SUBDOMAIN = "cats"; // the main app subdomain — not a tenant

export function getTenantSlug(): string | null {
  const hostname = window.location.hostname;

  // Local dev — no tenant
  if (hostname === "localhost" || hostname === "127.0.0.1") return null;

  // Must be a subdomain of bigdatamatica.com
  if (!hostname.endsWith(`.${BASE_DOMAIN}`)) return null;

  // Extract the subdomain (e.g. "infosys" from "infosys.bigdatamatica.com")
  const subdomain = hostname.slice(0, hostname.length - BASE_DOMAIN.length - 1);

  // The main app subdomain is not a tenant
  if (!subdomain || subdomain === MAIN_SUBDOMAIN) return null;

  return subdomain;
}

/** Returns headers object to spread into fetch/axios calls. */
export function tenantHeaders(): Record<string, string> {
  const slug = getTenantSlug();
  if (!slug) return {};
  return { "X-Tenant-Slug": slug };
}

/** Returns the full tenant URL for a given slug. */
export function tenantUrl(slug: string): string {
  return `${slug}.${BASE_DOMAIN}`;
}
